import axios from 'axios';

let userSettingsRequest = null;
let paymentSettingsRequest = null;

export default {
    namespaced: true,
    state: {
        userSettings: null,
        paymentSettings: null,
        userSettingsLoaded: false,
        paymentSettingsLoaded: false,
    },
    getters: {
        userSettings(state) {
            return state.userSettings;
        },
        paymentSettings(state) {
            return state.paymentSettings;
        },
    },
    mutations: {
        SET_USER_SETTINGS(state, data) {
            state.userSettings = data;
            state.userSettingsLoaded = true;
        },
        SET_PAYMENT_SETTINGS(state, data) {
            state.paymentSettings = data;
            state.paymentSettingsLoaded = true;
        },
    },
    actions: {
        loadUserSettings({ state, commit }, { force = false } = {}) {
            if (!force && state.userSettingsLoaded) {
                return Promise.resolve(state.userSettings);
            }

            if (userSettingsRequest) {
                return userSettingsRequest;
            }

            userSettingsRequest = axios.get('v1/public-settings/users')
                .then(response => {
                    const data = [{value: response.data?.member_settings || {}}];

                    commit('SET_USER_SETTINGS', data);

                    return data;
                })
                .finally(() => {
                    userSettingsRequest = null;
                });

            return userSettingsRequest;
        },
        loadPaymentSettings({ state, commit }, { force = false } = {}) {
            if (!force && state.paymentSettingsLoaded) {
                return Promise.resolve(state.paymentSettings);
            }

            if (paymentSettingsRequest) {
                return paymentSettingsRequest;
            }

            paymentSettingsRequest = axios.get('v1/public-settings/payments')
                .then(response => {
                    const settings = response.data || {};
                    const paymentMethods = settings.payment_methods || {};
                    const data = [{
                        value: {
                            currency_type: settings.currency,
                            payments_types: paymentMethods.types || [],
                            pay_pal_configured: paymentMethods.pay_pal_configured || false,
                            stripe_configured: paymentMethods.stripe_configured || false,
                        }
                    }];

                    commit('SET_PAYMENT_SETTINGS', data);

                    return data;
                })
                .finally(() => {
                    paymentSettingsRequest = null;
                });

            return paymentSettingsRequest;
        },
        loadSettings({ dispatch }, { force = false } = {}) {
            return Promise.all([
                dispatch('loadUserSettings', { force }),
                dispatch('loadPaymentSettings', { force }),
            ]);
        },
    },
};
